import React from 'react';


const Emph = ({children}) =>
  <span className="test-emph">{children}</span>;


export default Emph
